import { useContext } from 'react';
import BioContext from '../../store/bio-context';

const SkillSection = () => {
    const profileInfo = useContext(BioContext);
    return ( 
        <section>
            <h2 className="sectionHeading">TOOLS & TECHNOLOGIES, I HAVE USED SO FAR</h2>
            <div className="skills-row">
            {profileInfo.Skills && profileInfo.Skills.map(skill=> <img src={skill.icon} title={skill.name} alt={skill.name} key={skill.id} width="50" height="50" className="skill-item"/> )}
            </div>
        </section>
     );
}
 
export default SkillSection;